// From https://docs.google.com/spreadsheets/d/1vDXJaH8fo2B8QO6PuGdxSDRkAKl9-lHbKwDZL3220Ao/edit?gid=0#gid=0
export const antibioticVmpIdsSet = new Set([
  "b0b1ab0d-0b6b-4fb5-9420-c011830eefef",
  "077416ef-7daf-4a05-b13c-f6fdbe0c489e",
  "d3312c2a-fb2c-4ffd-8c7c-72d363c540c0",
  "013f3d63-b52e-472f-8b34-b5d96edcdee5",
  "1d3b6df4-32ef-4f8c-89e6-f8eeca13e9a0",
  "fc121944-df52-40c9-88ad-ce0cc7170046",
  "e4eec4bb-ac0d-4ca4-afb7-dbb97344691c",
  "4f06448c-889a-420a-ae52-9c578de2efc7",
  "2cda63e5-aa23-4df1-827f-45d6f41da05b",
  "457b678b-f97a-436a-9a64-796c8158f7f4",
  "e79ea63e-7cbb-4015-91d0-961eab98f475",
  "fed7c3a7-4bbb-4da9-98e7-6f2ebfc60fd0",
  "effb6e53-f256-4677-9d28-3393d387b54b",
  "138e4ce3-d90b-4435-9fb9-8d4e377b56f2",
  "442d69a3-7b3b-4703-9903-0bd1d4a10cfe",
  "21296ca4-29bb-46ea-8441-3f69063f8b6b",
  "4b61e18f-8651-4aa5-9786-5ad77d3a9add",
  "bc57ffe9-c375-49b0-9af5-28e73a7ba862",
  "b1144e66-8b23-437b-bf21-64049ed97f94",
  "6e7c0587-878a-40d2-bb99-ea9ff1c95200",
  "9ba0731b-b609-4241-9be6-a20e0da42511",
  "49379b9c-46d6-43e3-a153-0978930311ff",
  "1e1dae66-24cf-414d-b85e-2d4319618d93",
  "dc597f53-c96c-411f-a76e-d0eac89ccc91",
  "17240bfb-f197-4bcf-8648-abed5dee3f0b",
  "d8b0cc3d-bbce-42f3-aba1-a7b692618f2e",
  "2f3ef753-d4f7-496d-9f63-361dbd171aa8",
  "9a0a19e0-0252-4aad-a87d-fde46f4bc66f",
  "2985af11-7e40-40fc-ac54-f5394924fdcb",
  "9d64ddff-0c4d-41b9-8739-3c5f98284fec",
  "bd9f5157-187c-47a0-935b-00d1d902e046",
  "4f8034b2-e669-476e-ae9b-bf4d32f875f1",
  "35a27e5c-e025-4a9c-9e21-fc88d02d42d8",
  "4050a76d-75a6-4742-a744-fffa67363e73",
  "2b4cfcad-853c-4484-b6df-1ca7de25b659",
  "dfceeba5-70b9-4584-b7a4-dc25465c985a",
  "528c3c6a-4cf9-4aab-9a1c-b59ab8aa6e47",
  "28a90cb6-0132-4503-8e50-1bdc84470520",
  "f508a9dd-f4b3-4b5f-aae7-9cac513c8010",
  "62290c17-c9ba-4493-8e4d-37debb205ef8",
  "8aca410b-d23f-4ce1-8fbb-a9e94aecc11f",
  "98859136-f609-40db-9a73-061a162f36f8",
  "ec3c1a8a-ade2-441f-bd7f-a4b24bcda49f",
  "aad60ce6-801b-401b-bafe-79d330d5050d",
  "e587a143-7359-4904-9bcb-1ce5bf25e854",
  "c3e7ab2e-b17d-4544-97bc-788f6a8a50e6",
  "600bbed8-5c54-482f-9dbd-262b626330d6",
  "31230862-6683-484e-bce0-75500dedac7b",
  "be38d3a6-bea4-4593-999c-668b979c9920",
  "4d7be77c-042c-48ea-b98c-bc26afa84f20",
  "a50bb61b-38cb-45b4-a6a0-c46766173e76",
  "80d34131-69e7-411e-9e74-75493d88a2ae",
  "23ed2b57-fc4f-46f4-b6d6-f9ae3a589381",
  "1ca74590-b46c-4d3d-998b-0939c4c896ee",
  "657a1eef-003c-4f88-b79c-940370e051fe",
  "ed61ccad-1143-4bbe-8dfc-7a56ec396246",
  "098658fc-eea9-4058-8b33-eff65af05d69",
  "3fd349aa-c5d7-4f59-83a7-2903ecbc541c",
  "03d17791-cb6d-4d8b-a386-57bc1a74bd87",
  "3042bf43-c97d-4f06-a309-d6eb1a4acdad",
  "e95e18c1-bad7-4180-82ed-351ef86845f1",
  "2c801ca5-0f31-4a3d-9159-fde19fa1de89",
  "94f8fb60-4a14-43ca-ae62-926cea4462d4",
  "1b8ee2fb-8c19-44de-ae8b-362da7380231",
  "05101630-0914-4ce2-921e-d4fbe85d15b7",
  "ca00103e-b07a-403e-a1a4-339494045382",
  "7fe70f9d-babb-4649-85b6-b265916dc5b8",
  "9b55a35b-b667-46a2-a259-aa1cde842a49",
  "f427b1ad-5bad-4c54-a992-56bcd8d38880",
  "ea5b8dbf-b1f8-4765-8a61-4821410134ce",
  "91ee8e3c-8748-4e82-97f8-0bcdc1eabaca",
  "b9c608aa-d2e0-4552-aa31-a364817ed768",
  "bc7d9641-3455-410c-9096-18d844365cbb",
  "0790d13d-c7f0-4999-894a-74823fdc7c19",
  "51e5284a-a98b-4f9a-8a89-e17ab7b69b0b",
  "e30cd318-0235-4f76-900d-50ec3d4cfd29",
  "416030bc-9517-4589-bbdc-a95ac406176c",
  "1fa212c0-b70b-4cf1-b85a-53c432651416",
  "b3886835-7a5b-428e-a610-0cfd8311a421",
  "2f38d66b-11e4-491b-b089-eb5642a48cf9",
  "033f3ab4-babd-4fe2-8046-1d52ea645ab8",
  "0bb15065-508a-4464-ba0d-c30329d6faa7",
  "a4251e84-ed77-42fb-8fd3-3e28be4a7225",
  "eea2b6d3-e519-46a1-83eb-e8805a68d07a",
  "24ea1b60-a68f-4ab3-bb79-113c4f76aa77",
  "ddecd868-363e-4aaa-b6c1-6560899e8da4",
  "8a0a2cfb-41bb-4f32-999a-cf7a8a325663",
  "86d73b89-9f61-4d2d-87b4-696ea30df840",
  "805ee27a-7cb1-4630-bae1-e65bbe77fb8b",
  "dceb4248-9f50-47e9-addd-57fde816ba66",
  "d956814e-f448-4179-b806-7fb04ef56961",
  "a177705e-9ef1-4f27-9bcb-e14a40c121ff",
  "861f0ca9-242e-47b9-a725-78be9f8fd8bb",
  "8fbab29b-3e22-4731-81ac-ac5311aae883",
  "bfbe8657-ca2e-4c1d-9b97-6b3dfa2cf9d1",
  "6a5c147c-dc73-4589-8732-be18fe62f3fc",
  "b32fdde6-5068-4915-9f3b-a23a52be005d",
  "fc30eff0-b5e9-441b-8fce-766a5ac9effa",
  "d78b66e8-a12f-450d-9b3a-fd8f7c732ccd",
  "54e2348a-be97-4d48-996a-b5c2a66655f0",
  "3c1076e1-0217-4078-bf4a-b5508ffe7ec1",
  "5b3a1e18-79ce-4462-a695-047440e8b858",
  "3af03471-0076-4709-a85f-65256f83106e",
  "0cf80b92-3c13-4a69-acf5-36d3b89a2872",
  "d09a74e4-1ff2-4a6d-bb0f-44be5d2cc3df",
  "74fc0125-6386-4959-929b-2e992648ecc9",
  "3236d1f0-686a-460f-b1c4-417530f31fa7",
  "f955b0fe-d586-445d-b60f-bd510873241b",
  "0e2e44e1-e080-499a-ad40-0e80cbdd56e9",
  "5b390fc3-cfa4-4142-980f-916d59600419",
  "e912bdcc-e86b-41bd-927d-d86c6ba8848c",
  "b7d710b4-1b3f-4b8d-9480-cab90e0781ab",
  "ce34653a-7ffb-4f68-bbfa-99fd687b81f9",
  "d9d5902d-5759-4f11-bfe1-72831273738a",
  "2a3a511b-b8e2-47be-9e38-7cca9a2d77e1",
  "651d2cad-3598-4a25-8e41-ee150bd36408",
  "70b239e0-785e-450a-98cd-aa5169158cb0",
  "65e9c3c7-8437-4c4a-a904-3839b699efc0",
  "02f1dea0-c453-4fee-a870-574944376100",
  "c52c6559-8b15-4717-9077-b2703850edd8",
  "f854a828-bc18-4833-b685-998085b599d6",
  "5747c0bf-a5d4-41a6-b6bd-b0954e5bab64",
  "83fce35a-effb-4ea4-9045-146f3a7ba91d",
  "e556e7a6-e151-40af-92f1-25aea8078f46",
  "ada36a30-deca-43ee-b031-55667c3834d3",
  "2400d77a-aed3-49ab-af2a-bd306435efd0",
  "c77b336e-8d65-489e-84cc-c922b05b6486",
  "3787ef90-6ca0-4935-9517-cb9d8f81558c",
  "1dc5a9f0-412e-447f-af69-2cd2bbad9d99",
  "1d318753-b75f-4aa7-abfb-2538bd5b0496",
  "51069d92-7966-444c-93da-9c2fbcc1b3c0",
  "a2e87e31-93ec-4b75-973e-f15be10649e4",
  "7b5a3886-584d-4dac-ba70-ca91c48ed352",
  "03f41af5-ad6d-491d-953b-6621b35867af",
  "f3b5f6fa-0c3e-4cdb-a1b6-917ef78148c4",
  "de440a54-727d-47c2-aa3c-2cec0746d113",
  "cf730038-8420-4464-842d-ed7d206d4cc8",
  "f98766a8-ca09-4ef2-bba1-d2794e7ebc4d",
  "333d48ef-c742-4ed6-b49b-19a6b039d235",
  "abd50c36-489d-430c-9b7b-74a5addf9d69",
  "66dbd1bd-fff7-4742-8001-7eab6e5fdb39",
  "707a0a58-abfc-406e-a5b2-9deb454fb23e",
  "7e70347f-2456-47cb-8b59-9601ef22f3a0",
  "b10ddba3-a9fc-4617-8770-064c2ac81b0a",
  "ec0cf084-fddc-4406-b817-3c5251336d64",
  "15a48e1e-66a4-48af-8476-8056b2f48f69",
  "de432910-56d1-492d-a233-4031f05180dd",
  "0b043400-a0c4-45eb-8821-46dd6d8c78fd",
  "0f22ddef-0849-434f-945d-a7ab6476053c",
  "fee84393-85a1-4473-99e6-07490eaf2c08",
  "67e5d83e-b843-4648-b413-a0defc0bfb86",
  "2cc52f87-30d3-4f38-bb9f-2361a4e93c24",
  "858389f5-ac98-4da9-8643-2695fc5816a6",
  "003a8880-7006-45d6-8f57-0e6c387d5898",
  "5ae572f4-fbfa-4751-a592-1cfc833d5b0c",
  "ca2981df-b3a2-4e51-a841-83a64bd47ed6",
  "010fc45d-0d19-42db-929b-ab2c700d5e5a",
  "4f64a3c0-adb0-4268-b9be-8aa6ccc07850",
  "3531b632-f5ee-401e-95b1-3d2fa2e67309",
  "d18ccc16-6a96-4c8d-9e6f-eddaec546891",
  "38a78674-f1c8-4d11-8948-38be16f20487",
  "ba834fa5-fa6d-43a1-8cc3-4bdf9a8af095",
  "87f93823-dbb4-45cd-9377-7f57b6fdaa6e",
  "d1061ca6-a7dc-4e96-9a5c-dc2b5754b7e7",
  "e884a5b0-40bc-4c9c-8c3c-22f4d6e81c07",
  "0e6551f8-5d17-4843-a9a0-2e6cff1515c8",
  "78e5daad-17a3-4daf-8eaf-04faa555101c",
  "1e4c47c1-1276-42ed-99bc-51ccb851f40b",
  "26ac7804-6678-4d9c-b081-f5cb0b7aa5e6",
  "0fef29cd-14d9-4741-9266-becce9efaa44",
  "de87eb2a-9a8a-41ac-ae9e-e1692cf595f7",
  "5f832976-ac45-4c64-8286-f50664cf37ec",
  "6b0c6570-a17d-4c99-9451-e34175fecabf",
  "c3a75f70-6fd9-4118-9dc8-1efb38e6316e",
  "b0abbc99-fd31-4881-bdd1-558440d85658",
  "561d7828-e573-47fc-bccf-8f8f55e4386a",
  "09b518a0-8d49-4417-a8e1-72a1183087bd",
  "467fae56-7297-43e3-a47c-4ab62de6932f",
  "f0e57c6b-9ea7-4e93-9c88-9ecb42a75822",
  "bda90042-b987-45cc-922c-549790c08fa8",
  "4af674db-88fd-418d-8dd6-ae8992949b87",
  "b5c24a77-e611-41db-8725-2336a2a40d53",
  "8b3f5561-2473-4668-a54c-e3400710f186",
  "83850bde-d271-44f4-9914-629857559f76",
  "469de861-9725-4e01-b2ee-392f3160bc70",
  "58060451-6774-43c0-988d-e959641a994e",
  "6f5765f1-20d0-4275-8b11-1adc9c3b76a1",
  "c32834e4-85d8-42d7-8852-df72a66cade8",
  "ff9cd87c-a47e-429b-80e6-1bc9a5992aca",
  "99281316-f704-4af4-a975-1ae5f8417992",
  "e3699f98-5a11-4daf-8de2-6e04b2d54536",
  "66035e9c-bf57-44ef-9a82-7db5086964b6",
  "f17791cb-46a2-4d47-87d9-8e6c5640504c",
  "d2ce8057-c3f6-45ff-a250-9b3272590de7",
  "9283c790-66ca-435c-b0f2-9166b9f01cec",
  "022e1c49-a6a2-47f0-b311-f912ac00b112",
  "54d5ae8c-fe75-4b5e-87f7-db531adeb08c",
  "6876ef6e-6f26-4a9b-9b88-096b8355df04",
  "0f96e0cb-e6d8-4d40-b376-093c0689e9bb",
  "eaadc704-b685-466b-a328-50c0e502ff8f",
  "0569e391-baea-4b7b-a92f-e883389d3496",
  "eca430a2-271e-464b-b996-41d91d029bf7",
  "9c75983a-6981-4759-b50b-37390f58d563",
  "e339bff3-ed39-47dd-a5cf-e6ce51121bff",
  "8c0eef9d-221b-49b0-b73a-d9291ee14516",
  "41c38f63-611e-4868-b752-1c2ced949a16",
  "bd891e8f-4fcd-4275-871f-54ef6e82bafb",
  "30b79f72-679f-4c32-9a70-1449800f37bb",
  "5a6a7d3e-0fe3-4939-9244-4df830b6b408",
  "d36babff-bacb-4514-b09a-44966af03440",
  "bc839cbd-0896-4ea2-bf01-57c4508128a6",
  "85b0562f-9942-4af1-8e46-ad21a425058a",
  "62e2ab8c-c545-45fb-8d24-8ee7875f8d28",
  "34d86105-c700-4c8e-b943-d776b742152c",
  "16ee1be7-4d40-4ebd-801a-576b43d08abf",
  "0b9714e3-902a-4e89-84dd-0b0c365247d8",
  "fb663f25-159c-48b5-b9ba-8e5e1145fac8",
  "fca62c01-e082-4b31-83e8-da39fbe9c0bb",
  "c21332b1-d759-4302-9f4d-aa64d11e429d",
  "14643d37-d63f-49f5-9ec2-159ae726e707",
  "87d326b5-3dfc-46bd-8f12-d3610fefd1bd",
  "32e7642c-9393-4078-ba22-ff34a16e6988",
  "740ec8aa-f5d9-4896-9968-0be8711e912c",
  "0100382f-471e-4112-ac23-019e30ff9df3",
  "d15f79c6-0dd4-4101-b23d-c4f634c65270",
  "97873df9-58ba-49c3-b3ec-62a969083acf",
  "074ae067-52b0-45f4-8469-be7090197de0",
  "f70a84f5-d85b-4711-bf59-22a29c6d054a",
  "c90be4c5-b6f5-4b00-a2b1-07a4df5f7f9f",
  "25b75726-405e-4760-afed-0e90d528c244",
  "984c5d93-c7e4-49bf-a669-9bfb8aa6e0ca",
  "cf538e0b-64e0-459b-9807-2d8b1abc5d98",
  "847c635d-a704-4ec6-af3d-bbade6e2d9d7",
  "fd3138b6-b052-4cd1-bbbf-f1a6bad52819",
  "a5393d4e-cd20-42fa-9bdc-6c054b285d8a",
  "d421e922-8a66-4a0e-82fd-069b89995493",
  "ef026849-89b2-43f9-895c-282c07ac09f2",
  "3ab26335-7124-4664-8ff9-8f0fe042b75e",
  "69d19205-0c17-442e-85cd-a040c0527e13",
  "a979aa41-c43f-4070-b221-a6afa13f8cf3",
  "58a8e379-9597-4bfb-a1cf-780d2a4ffc29",
  "c4a68bcc-ead8-4849-9078-e6a34799a343",
  "12c5f7c6-4648-4b8b-8316-fbd4eaf6dcff",
  "fbb6b0bf-cef7-4a2f-b8e4-5dc3fe5cb6b6",
  "0aae6094-40f0-4a6a-b6dd-cd026d70272e",
  "10baaea4-cff4-4217-9a39-a6125f618967",
  "e360ca55-21a8-4b56-81eb-c242553b282d",
  "06f11bf7-d807-425d-968f-3fce72190094",
  "5c68eadc-bfc6-40f9-93cd-fa084f455195",
  "fbcfdb44-ab96-4bfa-845a-e97a039b25ee",
  "09198b8d-b408-483d-b824-2dabdbfbff21",
  "81fe406a-74f4-45c3-bb08-85bf3bf370af",
  "267041f5-161a-480b-a20d-bba4440c6d72",
  "ba1305aa-54e3-47c5-b63c-304e7e162bc1",
  "60c3ae60-fa1c-4900-b3cd-17a15a7e8257",
  "9ed63ce7-b279-49c8-9ba4-7c8ccbf30747",
  "33a07c30-9c45-4cc9-a1f7-e4204506acb1",
  "d6617ffc-18c9-4f66-8a52-b66e16264e38",
  "d5b55c6f-9a83-41a8-a40d-72c625c43ad2",
  "1c647bd4-615a-4af9-851f-46d8778f251f",
  "1ee6095c-997b-486b-9602-4d982d1176eb",
  "7905d689-7c93-4356-bf0e-23fd5fba4729",
  "7343fe5b-114d-4640-91c6-e71523568d2b",
  "92287628-6431-425f-abf2-04b15e2bdd4b",
  "88a2490e-e5f8-49d5-9d84-12a065aac165",
  "cc0093bf-90a8-4741-a4ad-3e7500a64c1c",
  "c666d1df-fb8e-44be-b8e9-13fc6fe0f14e",
  "19d7f3f5-5710-437e-a940-29623aa55bd3",
  "0589d577-7a8b-4fd8-8897-f27c2a3e74ff",
  "6fbd2c1e-27dd-48f9-9b06-4ca9f3fe4d74",
  "496b919b-606f-4af8-a1dc-fa320ae61cdd",
  "36ed6927-f303-4128-947f-7cc19d872ea7",
]);

export const antimalarialVmpIdsSet = new Set([
  "569a54ef-02e0-4b6a-8ada-ce9254b9c9ec",
  "4bcece96-9c5b-4a5e-8a52-711a74b181f8",
  "a599bcf2-b9be-41f4-87f0-9992894aaf03",
  "5a8a9b6e-6f19-40c6-9bce-12517f934811",
  "09a57a26-37f0-467b-acf8-68fd7aaf35fc",
  "2479fefa-b913-44d3-96dc-7a15a9f91a2c",
  "71abd0c4-8d8d-4c43-8cec-e92bb0855d22",
  "7d5ed854-a983-40f2-8db9-6382f3121ddc",
  "85a1075b-7bba-40ab-b095-44b285023623",
  "907d10a9-c11c-49bc-ab66-71c87795714e",
  "a6f0401c-1102-409b-9457-fe286167c2ab",
  "b3762868-b7b2-4bd7-9599-fa2df1bd8335",
  "d8628648-444f-485a-9176-4ed8dcd3d404",
  "90c147c4-9324-4745-9390-964f372aff1f",
  "948f282f-c565-483e-9328-354f449d4a9d",
  "6ca4a389-19ba-4f90-84bf-9cc05714352e",
  "f362a158-05a1-4da1-8270-99e95c02caa4",
  "70f0451a-2a92-4fa3-99ed-f97080de7d95",
  "df452374-eef0-4ef2-b7a8-f657e8ef1783",
  "ff45fc06-332c-4dbd-8ea3-1b9736b82d03",
  "6a066a60-6ee0-4566-bbf2-82234a27aae7",
  "3797d840-41f0-4f27-944d-aff259a2900a",
  "144876ba-a13b-4923-ae1d-ed33f77e9ef3",
  "5c3b693c-c8f2-417f-9411-df41a16de952",
  "eec53cc3-101a-4dd0-8f91-333f513554d2",
  "e9466bac-399e-4351-9069-404cf4a302ef",
  "819d3af6-9150-47c6-a074-bcc9709ad5aa",
  "1dd5d633-b675-4c85-bf44-601646b8e65d",
  "58f69e0f-b7bb-4589-a062-670416cade5d",
  "96f8cb1b-78d6-47ae-9e0c-ff7f5681dd80",
  "84d4ccb4-8d2e-466c-8f78-65ce39b43ace",
  "5f81b8d8-38a9-4669-8900-c512bc3d6e27",
  "50a749b5-18e3-4e2c-b35c-3d91854d60b1",
  "00eee08e-580d-4629-b7cc-20becd027ec5",
  "d59715d5-9cb6-4f59-935b-3bec7e34b800",
  "3e20f92b-be83-47ee-ad28-f6b53878ff87",
  "b756abb9-1cab-41f9-a314-10dcd9d83226",
  "d43deeef-f3e0-403f-95b1-a0b781605a33",
  "840020fd-4c72-43e1-b2d0-8cf56d3212dd",
  "e4246a00-841b-4071-8c10-8af82f8d25b0",
  "624fe349-a695-4a56-a2cd-08c2771e2c35",
  "6779b1c1-66a5-4c34-be18-4ad3702e09e7",
  "a01d886a-7a9c-42e7-bd71-2001fb362104",
  "c1de06fd-7cba-4e3b-96a9-cf69f7c985b3",
  "e79b4dd9-848c-4a4d-97eb-4d459fcea948",
  "00781d3d-4a38-4dd0-97ed-27cfc24f50b1",
]);
